import React from 'react'
import classNames from 'classnames'

import { BannerPropType } from './Banner.interface'
import ButtonDefault from '../ButtonDefault'
import Cross from 'app/components/SVGS/Cross'
import './styles.scss'

export const bc = 'base-banner'

export const Banner: React.FC<BannerPropType> = ({
  text,
  type,
  onClose,
  onButtonClick,
  buttonText,
  buttonProps,
  closable,
  disabled,
  okayLabel,
  cancelLabel,
  cancelAction,
  okayAction,
  children,
  className,
}) => {
  const renderButton = () => {
    switch (type) {
      case 'Confirm':
        return (
          <>
            <ButtonDefault className={`${bc}__button`} onClick={cancelAction} disabled={disabled}>
              {cancelLabel}
            </ButtonDefault>

            <ButtonDefault className={`${bc}__button`} onClick={okayAction} disabled={disabled}>
              {okayLabel}
            </ButtonDefault>
          </>
        )
      case 'Button':
        return (
          <>
            <ButtonDefault className={`${bc}__button`} onClick={onButtonClick} disabled={disabled} {...buttonProps}>
              {buttonText}
            </ButtonDefault>
          </>
        )

      case 'Default':
        return null
    }
  }

  return (
    <div className={classNames(bc, className)}>
      <div className={`${bc}__content`}>
        <h2 className={`${bc}__text`}>{text}</h2>
        <div>{children}</div>
        <div className={`${bc}__actions`}>{renderButton()}</div>
      </div>
      {closable && (
        <button className={`${bc}__closeButton`} disabled={disabled} onClick={onClose}>
          <Cross width="13" height="13" />
        </button>
      )}
    </div>
  )
}

export default Banner
